import { useEffect } from "react";
import Loader from "../../components/atoms/Loader";
import {
  OutletContextProps,
  WithRouterProps,
} from "../../helpers/RouterHelper";
import {
  AuthenticatedPageCallbacks,
  AuthenticatedPageProps,
} from "../../hocs/enhanceAuthenticatedPage";
import enhanceSectionsSettingsPage from "../../hocs/enhanceSectionsSettingsPage";
import { useQueryError } from "../../hooks/http/useQueryError";
import SectionInterface from "../../interfaces/SectionInterface";
import SectionsSettingsStudyRecordSkillsNewPage from "./SectionsSettingsStudyRecordSkillsNewPage";
import { useFetchSkillMaster } from "./useFetchSkillMaster";

interface Params {
  id: string;
}

type Props = WithRouterProps<Params> & {
  section: SectionInterface;
} & AuthenticatedPageCallbacks &
  AuthenticatedPageProps &
  OutletContextProps;

const Page = (props: Props) => {
  useEffect(() => {
    props.setActiveMenu("skills");
  }, []);

  const {
    data: skillMaster,
    error,
    isPending,
  } = useFetchSkillMaster({
    skillMasterId: props.params.id,
  });
  useQueryError(error);

  if (isPending || !skillMaster) {
    return <Loader loading />;
  }

  return (
    <SectionsSettingsStudyRecordSkillsNewPage
      {...props}
      skillMaster={skillMaster}
    />
  );
};

const pageInfo = {
  title: "アシスタント",
};

export default enhanceSectionsSettingsPage(Page, pageInfo, ["assistant:index"]);
